/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Top_Tapir_ComposeInputs */

const fr_quiet_top_tapir_compose = /** @type {(inputs: Quiet_Top_Tapir_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes vous sur de vouloir cloturer la demande. Il ne sera plus possible d'échanger avec cet personne.`)
};

/**

* @param {Quiet_Top_Tapir_ComposeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const quiet_top_tapir_compose = /** @type {((inputs?: Quiet_Top_Tapir_ComposeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Top_Tapir_ComposeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_quiet_top_tapir_compose(inputs)
});